import { render, staticRenderFns } from "./AbBothSideTeamPerformance.vue?vue&type=template&id=4b6ff8e1&scoped=true"
import script from "./AbBothSideTeamPerformance.vue?vue&type=script&lang=js"
export * from "./AbBothSideTeamPerformance.vue?vue&type=script&lang=js"
import style0 from "./AbBothSideTeamPerformance.vue?vue&type=style&index=0&id=4b6ff8e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ff8e1",
  null
  
)

export default component.exports